// extracted by mini-css-extract-plugin
export default {"section2":"section2_section2__b7rqs","content_box":"section2_content_box__YUO7O","title1":"section2_title1__rZkiA","hero_title1":"section2_hero_title1__ZSlwM"};